<template>
  <div class="positive-record-view">
    <my-form
      ref="overFormRef"
      :data="rowData"
      :loading="formLoading"
      :option="option"
      page-key="view"
      :footer-visible="false"
      width="auto"
    />
    <template v-if="assessmentShow">
      <my-form
        :data="assessmentData"
        :option="assessmentOption"
        page-key="view"
        :footer-visible="false"
        :loading="formLoading"
        width="auto"
      />
      <time-line
        v-if="rowData.assessmentProcessId!==-1"
        :data="formatHistoryData"
        title-hide
      >
        <template slot="title">
          <h3
            class="text-primary"
          >
            {{ i18n('labelPositiveRecord.assessmentTitle') }}
          </h3>
        </template>
      </time-line>
      <b-img
        v-if="rowData.assessmentProcessId && rowData.assessmentProcessId!==-1"
        :src="`/api/blade-flow/process/diagram-view?processInstanceId=${rowData.assessmentProcessInstanceId}&processDefinitionId=`"
      />
    </template>
    <template v-if="positivehow">
      <my-form
        :data="positiveData"
        :option="positiveOption"
        page-key="view"
        :footer-visible="false"
        :loading="formLoading"
        width="auto"
      />
      <time-line
        :data="formatHistoryData2"
        title-hide
      >
        <template slot="title">
          <h3
            class="text-primary"
          >
            {{ i18n('labelPositiveRecord.positiveTitle') }}
          </h3>
        </template>
      </time-line>
      <b-img
        v-if="rowData.positiveProcessId && rowData.positiveProcessId!==-1"
        :src="`/api/blade-flow/process/diagram-view?processInstanceId=${rowData.positiveProcessInstanceId}&processDefinitionId=`"
      />
    </template>
  </div>
</template>

<script>
import positiveRecordAPI from '@/api/staff/positiveRecord/index';
import MyForm from '@/components/myForm/index.vue';
import {
  BImg,
} from 'bootstrap-vue'
import TimeLine from '@/components/timeLine.vue'
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import { templateFormat } from '@/util/func'

export default {
  components: {
    MyForm,
    // BButton,
    BImg,
    TimeLine,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    staffId: {
      type: String,
      default: '',
    },
    assessmentShow: {
      type: Boolean,
      default: true,
    },
    positivehow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: {},
      formLoading: false,
      assessmentColumn: [],
      assessmentData: {},
      positiveData: {},
      positiveColumn: [],
      historyData: [],
      historyData2: [],
    }
  },
  computed: {
    assessmentOption() {
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: true, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: this.assessmentColumn,
      }
      return option
    },
    positiveOption() {
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: true, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: this.positiveColumn,
      }
      return option
    },
    formatHistoryData() {
      const res = []
      const temp = this.historyData
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return (b.endTime > a.endTime ? -1 : 1)
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (i === this.historyData.length - 1 && !item.historyActivityName && this.historyData.length > 2) {
          title = 'OA END'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeName}`
        const remark = `Remarks: ${item.comment}`
        if (!item.historyActivityDurationTime && i > 0) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }
        if (i > 0 && item.historyActivityDurationTime) {
          if (!item.pass) {
            variant = 'danger'
          }
        }
        res.push(
          {
            title,
            tip,
            info,
            remark,
            variant,
          },
        )
      })
      return res
    },
    formatHistoryData2() {
      const res = []
      const temp = this.historyData2
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return (b.endTime > a.endTime ? -1 : 1)
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (i === this.historyData2.length - 1 && !item.historyActivityName && this.historyData2.length > 2) {
          title = 'OA END'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeName}`
        const remark = `Remarks: ${item.comment}`
        if (!item.historyActivityDurationTime && i > 0) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }
        if (i > 0 && item.historyActivityDurationTime) {
          if (!item.pass) {
            variant = 'danger'
          }
        }
        res.push(
          {
            title,
            tip,
            info,
            remark,
            variant,
          },
        )
      })
      return res
    },
  },
  watch: {
    id: {
      handler(e) {
        this.onload(e)
      },
      immediate: true,
      deep: true,
    },
    staffId: {
      handler(e) {
        positiveRecordAPI.getList(1, -1, { staffId: e }).then(res => {
          const result = res.data.data.records
          if (result.length > 0) {
            this.onload(result[0].id)
          }
        })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    onload(id) {
      if (!id) { return }
      this.formLoading = true
      positiveRecordAPI.detail({ id }).then(result => {
        const row = result.data.data
        this.rowData = row
        if (row.assessmentProcessId && row.assessmentProcessId !== -1) {
          applyAPI.detail({ id: row.assessmentProcessId }).then(res => {
            const { data } = res.data
            this.assessmentData = data.map || {}
            templateFormAPI.detail({ formId: data.formId }).then(templateRes => {
              const temp = templateRes.data.data.records
              this.assessmentColumn = templateFormat(temp)
              this.formLoading = false
            })
          })
          applyAPI.history({ processInstanceId: row.assessmentProcessInstanceId }).then(applyRes => {
            this.historyData = applyRes.data.data
          })
        }
        if (row.positiveProcessId && row.positiveProcessId !== -1) {
          applyAPI.detail({ id: row.positiveProcessId }).then(res => {
            const { data } = res.data
            this.positiveData = data.map || {}
            templateFormAPI.detail({ formId: data.formId }).then(templateRes => {
              const temp = templateRes.data.data.records
              this.positiveColumn = templateFormat(temp)
              this.formLoading = false
            })
          })
          applyAPI.history({ processInstanceId: row.positiveProcessInstanceId }).then(applyRes => {
            this.historyData2 = applyRes.data.data
          })
        }
      })
    },
  },
}
</script>

<style>

</style>
